import { render } from "./UpsertUserComponent.vue?vue&type=template&id=4521cad7&scoped=true"
import script from "./UpsertUserComponent.vue?vue&type=script&lang=js"
export * from "./UpsertUserComponent.vue?vue&type=script&lang=js"

import "./UpsertUserComponent.vue?vue&type=style&index=0&id=4521cad7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4521cad7"]])

export default __exports__